import { CompanyManagerPaths } from 'app/configs/routesConfig/companyManager';
import { PATH_PROFILE } from 'app/configs/routesConfig/profilePage';
import { TpoCertificationPaths } from 'app/configs/routesConfig/tpoCertification';

import { PATH_AUTO_LOGIN, PATH_LOGIN, PATH_SSO_LOGIN } from 'constants/authPaths';
import { CERTIFICATION_PENDING_ALLOWED_TABS } from 'constants/companyManager';

// DEV-4953 strips an uncertified sub-company's loan/pipeline claim families server-side, but the
// AdminPanel shell routes (Command Center, Welcome, `/`) carry no page code and are
// `isAllowedWithoutRoles`, so hasPermission waves them through and a broker mid-signup lands on the
// full dashboard. Until the certification is approved the reachable surfaces are the certification
// flow itself, the auth routes that get the user in and out of it, and the user's own profile —
// personal account settings are not a broker tool, and the account menu links to them everywhere.
// Subtrees are reachable too, so `/tpo-certification/:subCompanyId` and the profile tabs resolve.
const CERTIFICATION_PENDING_ALLOWED_PATH_PREFIXES = [
  TpoCertificationPaths.tpoCertification.path,
  PATH_PROFILE,
  PATH_LOGIN,
  PATH_SSO_LOGIN,
  PATH_AUTO_LOGIN,
];

// Company Manager is exact-match ONLY, unlike the prefixes above. The certification iframe's
// `continue-to-company` hand-off pushes the bare path (which resolves to the certification tab) the
// moment the wizard completes, while the redux status is still pending — without this the CTA
// bounces back into the flow it just finished. But every Company Manager panel sits behind ONE page
// code, so allowing the subtree would let an uncertified broker administer security groups, invite
// team members and edit compensation before the lender has approved them. Only the hand-off target
// and the Tasks tab are exempt; CompanyManagerPage hides the rest of the tab strip to match.
const CERTIFICATION_PENDING_ALLOWED_EXACT_PATHS = [
  CompanyManagerPaths.companyManager.path,
  ...CERTIFICATION_PENDING_ALLOWED_TABS.map(
    tab => `${CompanyManagerPaths.companyManager.path}/${tab}`,
  ),
];

export const checkIsPathAllowedWhileCertificationPending = pathname =>
  CERTIFICATION_PENDING_ALLOWED_EXACT_PATHS.includes(pathname) ||
  CERTIFICATION_PENDING_ALLOWED_PATH_PREFIXES.some(
    allowedPath => pathname === allowedPath || pathname.startsWith(`${allowedPath}/`),
  );
